import { render, staticRenderFns } from "./Somos.vue?vue&type=template&id=cf37dede"
import script from "./Somos.vue?vue&type=script&lang=js"
export * from "./Somos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf37dede')) {
      api.createRecord('cf37dede', component.options)
    } else {
      api.reload('cf37dede', component.options)
    }
    module.hot.accept("./Somos.vue?vue&type=template&id=cf37dede", function () {
      api.rerender('cf37dede', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sobre/somos/Somos.vue"
export default component.exports